<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M18 10C18 5.589 14.411 2 10 2C5.589 2 2 5.589 2 10C2 14.411 5.589 18 10 18C14.411 18 18 14.411 18 10ZM10.043 13.457L7.293 10.707C7.098 10.512 7 10.256 7 10C7 9.744 7.098 9.488 7.293 9.293L10.043 6.543C10.434 6.152 11.066 6.152 11.457 6.543C11.848 6.934 11.848 7.566 11.457 7.957L9.414 10L11.457 12.043C11.848 12.434 11.848 13.066 11.457 13.457C11.066 13.848 10.434 13.848 10.043 13.457Z"
            fill="currentColor"
        />
    </svg>
</template>
